import {
  ActivityPageSchema,
  ActivitySchema,
  AgentRunListSchema,
  type AgentRun,
  AiAgentListSchema,
  AiAgentSchema,
  AiBudgetSummarySchema,
  type AiBudgetSummary,
  AiRooftopPromptListSchema,
  AiRooftopPromptSchema,
  AiSkillListSchema,
  AiSkillSchema,
  CreateAiSkillSchema,
  UpdateAiAgentSchema,
  UpdateAiSkillSchema,
  UpsertAiRooftopPromptSchema,
  type AiRooftopPrompt,
  type CreateAiSkillDto,
  type UpdateAiAgentDto,
  type UpdateAiSkillDto,
  type UpsertAiRooftopPromptDto,
  ConsentEventSchema,
  ContactVehicleSchema,
  CreateConsentEventSchema,
  CreateContactVehicleSchema,
  CreateFollowUpSchema,
  ContactTagListSchema,
  ContactTagSchema,
  CreateTagSchema,
  UpdateTagSchema,
  CreateTradeInSchema,
  CreateUserMembershipSchema,
  CreateUserSchema,
  InviteUserSchema,
  CreateVehicleInterestSchema,
  FollowUpPageSchema,
  ConsentEventPageSchema,
  TradeInPageSchema,
  VehicleInterestPageSchema,
  ContactVehiclePageSchema,
  FollowUpSchema,
  ServiceTypeListSchema,
  TagListSchema,
  TagSchema,
  TradeInSchema,
  UpdateMyProfileSchema,
  UpdateUserMembershipSchema,
  UpdateUserSchema,
  UserListSchema,
  UserMembershipListSchema,
  UserMembershipSchema,
  UserSchema,
  VehicleInterestSchema,
  type AiAgent,
  type AiSkill,
  type ConsentEvent,
  type ContactVehicle,
  type CreateConsentEventDto,
  type CreateContactVehicleDto,
  type CreateFollowUpDto,
  type ContactTag,
  type CreateTagDto,
  type UpdateTagDto,
  type CreateTradeInDto,
  type CreateUserDto,
  type CreateUserMembershipDto,
  type InviteUserDto,
  type CreateVehicleInterestDto,
  type FollowUp,
  type FollowUpPage,
  type ConsentEventPage,
  type TradeInPage,
  type VehicleInterestPage,
  type ContactVehiclePage,
  type Tag,
  type TradeIn,
  type UpdateMyProfileDto,
  type UpdateUserDto,
  type UpdateUserMembershipDto,
  type User,
  type UserMembership,
  type VehicleInterest,
  CalendarAppointmentPageSchema,
  AppointmentSchema,
  ChannelOnboardingInfoSchema,
  ChannelPageSchema,
  ChannelSchema,
  AgentCardSchema,
  AapValidationResultSchema,
  ConnectAapChannelSchema,
  ConnectApiChannelSchema,
  ConnectEmailChannelSchema,
  ConnectTelegramChannelSchema,
  ConnectWhatsAppEmbeddedSignupSchema,
  ConnectWidgetChannelSchema,
  EmailAddressAvailabilitySchema,
  type EmailAddressAvailability,
  ContactChannelPageSchema,
  ContactChannelSchema,
  ContactActivityPageSchema,
  ContactIntegrationSyncSchema,
  ContactLeadPageSchema,
  ContactPageSchema,
  ContactSchema,
  LeadAssignSchema,
  LeadFeedSchema,
  type LeadBoard,
  LeadBoardSchema,
  type LeadFeed,
  NeedsYouFeedSchema,
  type NeedsYouFeed,
  InboxCountsSchema,
  type InboxCounts,
  type InboxView,
  BulkLeadActionSchema,
  BulkLeadActionResultSchema,
  type BulkLeadActionInput,
  type BulkLeadActionResult,
  LeadPageSchema,
  LeadAiSummaryResultSchema,
  LeadSchema,
  LeadSnoozeSchema,
  CreateAppointmentSchema,
  CreateContactChannelBodySchema,
  CreateContactSchema,
  CreateLeadSchema,
  ImportContactsSchema,
  ImportContactsResultSchema,
  type ImportContactsDto,
  type ImportContactsResult,
  MergeContactsSchema,
  MergeContactsResultSchema,
  ResolveOrCreateContactSchema,
  RejectActivityApprovalSchema,
  type RejectActivityApprovalDto,
  ReportCurrentSlaBreachesPageSchema,
  type ReportCurrentSlaBreachesPage,
  type ReportCurrentSlaBreachesQuery,
  type MergeContactsDto,
  type MergeContactsResult,
  DealershipSchema,
  AttachmentUploadUrlResultSchema,
  CreateAttachmentUploadUrlSchema,
  TranscribeAttachmentResultSchema,
  InternalNoteSchema,
  SendLeadMessageSchema,
  SuggestedResponseSchema,
  RooftopListSchema,
  RooftopSchema,
  UpdateAppointmentSchema,
  UpdateChannelSchema,
  UpdateContactChannelSchema,
  UpdateContactSchema,
  UpdateLeadSchema,
  type Activity,
  type ActivityPage,
  type Appointment,
  type CalendarAppointmentPage,
  type CalendarAppointmentQuery,
  type ServiceType,
  type Channel,
  type ChannelOnboardingInfo,
  type ChannelPage,
  type AgentCard,
  type AapValidationResult,
  type ConnectAapChannelDto,
  type ConnectApiChannelDto,
  type ConnectEmailChannelDto,
  type ConnectTelegramChannelDto,
  type ConnectWhatsAppEmbeddedSignupDto,
  type ConnectWidgetChannelDto,
  type StartMetaOAuthDto,
  type Contact,
  type ContactActivityFilter,
  type ContactActivityPage,
  type ContactChannel,
  type ContactChannelPage,
  type ContactIntegrationSync,
  type ContactLeadPage,
  type ContactLeadView,
  type ContactPage,
  type Lead,
  type LeadAssignDto,
  type LeadPage,
  type LeadPipelineFilters,
  type LeadPipelineSort,
  type LeadSnoozeDto,
  type CreateAppointmentDto,
  type CreateContactChannelDto,
  type CreateContactDto,
  type CreateLeadDto,
  type ResolveOrCreateContactDto,
  type StartConversationDto,
  type Dealership,
  type AttachmentUploadUrlResult,
  type CreateAttachmentUploadUrlDto,
  type TranscribeAttachmentResult,
  type InternalNoteDto,
  type SendLeadMessageDto,
  type Rooftop,
  type UpdateRooftopScheduleDto,
  type UpdateAppointmentDto,
  type UpdateChannelDto,
  type UpdateContactChannelDto,
  type UpdateContactDto,
  type UpdateLeadDto,
} from "@lumika/shared";
import { z } from "zod";
import {
  appendListFilterParams,
  type ListFilterState,
} from "../lib/list-filters";
import { apiFetch } from "./client";

function appendLeadPipelineFilters(
  params: URLSearchParams,
  filters: LeadPipelineFilters,
): void {
  if (filters.search?.trim()) params.set("search", filters.search.trim());
  if (filters.stage) params.set("stage", filters.stage);
  if (filters.type) params.set("type", filters.type);
  if (filters.assignedUserId) params.set("assignedUserId", filters.assignedUserId);
  if (filters.unassigned) params.set("unassigned", filters.unassigned);
  if (filters.rooftopId) params.set("rooftopId", filters.rooftopId);
  if (filters.source) params.set("source", filters.source);
  if (filters.createdFrom) params.set("createdFrom", filters.createdFrom);
  if (filters.createdTo) params.set("createdTo", filters.createdTo);
  if (filters.lastActivityFrom) params.set("lastActivityFrom", filters.lastActivityFrom);
  if (filters.lastActivityTo) params.set("lastActivityTo", filters.lastActivityTo);
  if (filters.nextAction) params.set("nextAction", filters.nextAction);
  if (filters.includeAnonymous) params.set("includeAnonymous", filters.includeAnonymous);
}

/** Server response to GET /channels/oauth/meta/start. */
const MetaOAuthStartResponseSchema = z.object({ authUrl: z.string().url() });

/** Shape returned by POST /channels/:id/verify. Mirrors ChannelVerifyResult on the backend. */
const ChannelVerifyResultSchema = z.object({
  channelId: z.string(),
  type: z.string(),
  ok: z.boolean(),
  status: z.string(),
  details: z.record(z.unknown()).optional(),
  checkedAt: z.string(),
});
export type ChannelVerifyResult = z.infer<typeof ChannelVerifyResultSchema>;

// Shared query-string builder for the per-contact Customer-360 lists, all of
// which take an optional contactId filter plus page/pageSize pagination.
function contactListQuery(
  contactId?: string,
  opts: { page?: number; pageSize?: number } = {},
): string {
  const params = new URLSearchParams();
  if (contactId) params.set("contactId", contactId);
  if (opts.page) params.set("page", String(opts.page));
  if (opts.pageSize) params.set("pageSize", String(opts.pageSize));
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}

export const bdcApi = {
  dealership: (): Promise<Dealership> => apiFetch("/dealership", DealershipSchema),
  rooftops: (): Promise<Rooftop[]> => apiFetch("/rooftops", RooftopListSchema),
  /**
   * Exact current SLA exceptions. The backend applies the overdue predicate,
   * filters, and pagination before returning an exact total; callers must not
   * recreate this report by filtering an Inbox page.
   */
  currentSlaBreaches: (
    query: Partial<ReportCurrentSlaBreachesQuery> = {},
  ): Promise<ReportCurrentSlaBreachesPage> => {
    const params = new URLSearchParams();
    if (query.page) params.set("page", String(query.page));
    if (query.pageSize) params.set("pageSize", String(query.pageSize));
    if (query.rooftopId) params.set("rooftopId", query.rooftopId);
    if (query.assignedUserId) params.set("assignedUserId", query.assignedUserId);
    if (query.type) params.set("type", query.type);
    const qs = params.toString();
    return apiFetch(
      `/reports/current-sla-breaches${qs ? `?${qs}` : ""}`,
      ReportCurrentSlaBreachesPageSchema,
    );
  },

  updateRooftopSchedule: (
    rooftopId: string,
    body: UpdateRooftopScheduleDto,
  ): Promise<Rooftop> =>
    apiFetch(`/rooftops/${rooftopId}/schedule`, RooftopSchema, {
      method: "PATCH",
      body: JSON.stringify(body),
    }),
  users: (): Promise<User[]> => apiFetch("/users", UserListSchema),
  createUser: (input: Omit<CreateUserDto, "dealershipId">): Promise<User> => {
    const body = CreateUserSchema.omit({ dealershipId: true }).parse(input);
    return apiFetch("/users", UserSchema, { method: "POST", body: JSON.stringify(body) });
  },
  // Invite a teammate atomically: creates the user, grants access at the
  // chosen location(s), and emails the welcome link in one server call.
  inviteUser: (input: InviteUserDto): Promise<User> => {
    const body = InviteUserSchema.parse(input);
    return apiFetch("/users/invite", UserSchema, { method: "POST", body: JSON.stringify(body) });
  },
  updateUser: (userId: string, input: UpdateUserDto): Promise<User> => {
    const body = UpdateUserSchema.parse(input);
    return apiFetch(`/users/${userId}`, UserSchema, {
      method: "PATCH",
      body: JSON.stringify(body),
    });
  },
  removeUser: (userId: string): Promise<void> =>
    apiFetch(`/users/${userId}`, UserSchema.optional(), { method: "DELETE" }) as Promise<void>,
  /**
   * Self-service profile edit (Account settings). PATCHes only the
   * whitelist the caller is allowed to change on themselves — identity
   * and access fields (email, status, kind) stay behind the
   * manage-users-gated updateUser. Callers invalidate the same "me" +
   * ["bdc","users"] keys the avatar mutations touch so every surface that
   * names this user refreshes.
   */
  updateMyProfile: (input: UpdateMyProfileDto): Promise<User> => {
    const body = UpdateMyProfileSchema.parse(input);
    return apiFetch("/users/me", UserSchema, {
      method: "PATCH",
      body: JSON.stringify(body),
    });
  },
  /** Mint a presigned PUT for the caller's avatar (staged privately,
   * published to the CDN by setMyAvatar). */
  createMyAvatarUploadUrl: (input: {
    fileName?: string;
    mimeType: string;
  }): Promise<{ uploadUrl: string; key: string; expiresAt: string }> =>
    apiFetch(
      "/users/me/avatar/upload-url",
      z.object({
        uploadUrl: z.string(),
        key: z.string(),
        expiresAt: z.string(),
      }),
      { method: "POST", body: JSON.stringify(input) },
    ),
  setMyAvatar: (key: string): Promise<User> =>
    apiFetch("/users/me/avatar", UserSchema, {
      method: "POST",
      body: JSON.stringify({ key }),
    }),
  removeMyAvatar: (): Promise<User> =>
    apiFetch("/users/me/avatar", UserSchema, { method: "DELETE" }),
  memberships: (): Promise<UserMembership[]> =>
    apiFetch("/memberships", UserMembershipListSchema),
  createMembership: (
    userId: string,
    input: Omit<CreateUserMembershipDto, "dealershipId" | "userId">,
  ): Promise<UserMembership> => {
    const body = CreateUserMembershipSchema.omit({ dealershipId: true, userId: true }).parse(input);
    return apiFetch(`/users/${userId}/memberships`, UserMembershipSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  updateMembership: (
    membershipId: string,
    input: UpdateUserMembershipDto,
  ): Promise<UserMembership> => {
    const body = UpdateUserMembershipSchema.parse(input);
    return apiFetch(`/memberships/${membershipId}`, UserMembershipSchema, {
      method: "PATCH",
      body: JSON.stringify(body),
    });
  },
  removeMembership: (membershipId: string): Promise<void> =>
    apiFetch(`/memberships/${membershipId}`, UserMembershipSchema.optional(), {
      method: "DELETE",
    }) as Promise<void>,
  contacts: (
    opts: {
      search?: string;
      filters?: ListFilterState;
      includeAnonymous?: boolean;
      page?: number;
      pageSize?: number;
      /** `<column>:<asc|desc>` — server-side sort (whitelisted). */
      sort?: string;
    } = {},
  ): Promise<ContactPage> => {
    const params = new URLSearchParams();
    if (opts.search?.trim()) params.set("search", opts.search.trim());
    if (opts.filters) appendListFilterParams(params, opts.filters);
    // The directory shows only CONVERTED contacts by default — anonymous
    // (unconverted lead) rows live in the inbox, not the people directory.
    // The caller opts in to surface them, matching the inbox's flag.
    if (opts.includeAnonymous === true) {
      params.set("includeAnonymous", "true");
    }
    if (opts.page) params.set("page", String(opts.page));
    if (opts.pageSize) params.set("pageSize", String(opts.pageSize));
    if (opts.sort) params.set("sort", opts.sort);
    const qs = params.toString();
    return apiFetch(`/contacts${qs ? `?${qs}` : ""}`, ContactPageSchema);
  },
  /** Fetch a single contact by id (the detail surfaces shouldn't pull the
      whole contact list and find one — that misses anyone past page 1). */
  contact: (contactId: string): Promise<Contact> =>
    apiFetch(`/contacts/${contactId}`, ContactSchema),
  /** Distinct lead sources in use — feeds the contacts/inbox filter. */
  contactLeadSources: (): Promise<string[]> =>
    apiFetch("/contact-lead-sources", z.array(z.string())),
  createContact: (input: Omit<CreateContactDto, "dealershipId">): Promise<Contact> => {
    const body = CreateContactSchema.omit({ dealershipId: true }).parse(input);
    return apiFetch("/contacts", ContactSchema, { method: "POST", body: JSON.stringify(body) });
  },
  /**
   * Find-or-create a contact by primaryPhone or primaryEmail. If an existing
   * contact or contact_channels row already owns the identity, returns it
   * without creating a duplicate. Used by the "Start Conversation" dialog.
   */
  resolveOrCreateContact: (input: ResolveOrCreateContactDto): Promise<Contact> => {
    const body = ResolveOrCreateContactSchema.parse(input);
    return apiFetch("/contacts/resolve-or-create", ContactSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  /**
   * O2 — bulk CSV import (already column-mapped client-side). Setup
   * managers only; the server dedupes through contact_channels and
   * returns the honest created/merged/skipped breakdown.
   */
  importContacts: (input: ImportContactsDto): Promise<ImportContactsResult> => {
    const body = ImportContactsSchema.parse(input);
    return apiFetch("/contacts/import", ImportContactsResultSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  updateContact: (contactId: string, input: UpdateContactDto): Promise<Contact> => {
    const body = UpdateContactSchema.parse(input);
    return apiFetch(`/contacts/${contactId}`, ContactSchema, {
      method: "PATCH",
      body: JSON.stringify(body),
    });
  },
  contactChannels: (contactId?: string): Promise<ContactChannelPage> => {
    const qs = contactId ? `?contactId=${encodeURIComponent(contactId)}` : "";
    return apiFetch(`/contact-channels${qs}`, ContactChannelPageSchema);
  },
  createContactChannel: (
    input: Omit<CreateContactChannelDto, "dealershipId">,
  ): Promise<ContactChannel> => {
    const body = CreateContactChannelBodySchema.parse(input);
    return apiFetch("/contact-channels", ContactChannelSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  updateContactChannel: (
    contactChannelId: string,
    input: UpdateContactChannelDto,
  ): Promise<ContactChannel> => {
    const body = UpdateContactChannelSchema.parse(input);
    return apiFetch(`/contact-channels/${contactChannelId}`, ContactChannelSchema, {
      method: "PATCH",
      body: JSON.stringify(body),
    });
  },
  removeContactChannel: (contactChannelId: string): Promise<void> =>
    apiFetch(`/contact-channels/${contactChannelId}`, ContactChannelSchema.optional(), {
      method: "DELETE",
    }) as Promise<void>,
  leads: (
    closed: "true" | "false" = "false",
    options: { includeAnonymous?: boolean; contactId?: string } = {},
  ): Promise<LeadPage> => {
    const params = new URLSearchParams({ closed });
    if (options.includeAnonymous) params.set("includeAnonymous", "true");
    if (options.contactId) params.set("contactId", options.contactId);
    return apiFetch(`/leads?${params.toString()}`, LeadPageSchema);
  },
  /** Exact Contact 360 Lead counts and one server-filtered page. */
  contactLeads: (
    contactId: string,
    options: {
      view?: ContactLeadView;
      page?: number;
      pageSize?: number;
    } = {},
  ): Promise<ContactLeadPage> => {
    const params = new URLSearchParams();
    if (options.view) params.set("view", options.view);
    if (options.page) params.set("page", String(options.page));
    if (options.pageSize) params.set("pageSize", String(options.pageSize));
    const qs = params.toString();
    return apiFetch(
      `/contacts/${contactId}/leads${qs ? `?${qs}` : ""}`,
      ContactLeadPageSchema,
    );
  },
  /** Complete, server-filtered and paginated Leads List. */
  leadDirectory: (
    query: LeadPipelineFilters & {
      page?: number;
      pageSize?: number;
      sort?: LeadPipelineSort;
    } = {},
  ): Promise<LeadPage> => {
    const params = new URLSearchParams();
    appendLeadPipelineFilters(params, query);
    if (query.page) params.set("page", String(query.page));
    if (query.pageSize) params.set("pageSize", String(query.pageSize));
    if (query.sort) params.set("sort", query.sort);
    const qs = params.toString();
    return apiFetch(`/leads${qs ? `?${qs}` : ""}`, LeadPageSchema);
  },
  /** Leads Board (kanban): columns by pipeline stage with counts + first page. */
  leadsBoard: (
    filters: LeadPipelineFilters = {},
  ): Promise<LeadBoard> => {
    const params = new URLSearchParams();
    appendLeadPipelineFilters(params, filters);
    const qs = params.toString();
    return apiFetch(`/leads/board${qs ? `?${qs}` : ""}`, LeadBoardSchema);
  },
  /**
   * One additional page of a single kanban column. Use the previous
   * page's `nextCursor` to fetch the next one; null means end of column.
   */
  leadsBoardColumn: (
    status: Lead["status"],
    filters: LeadPipelineFilters = {},
    options: { cursor?: string | null; limit?: number } = {},
  ): Promise<LeadFeed> => {
    const params = new URLSearchParams({ status });
    appendLeadPipelineFilters(params, filters);
    if (options.cursor) params.set("cursor", options.cursor);
    if (options.limit) params.set("limit", String(options.limit));
    return apiFetch(`/leads/board/column?${params.toString()}`, LeadFeedSchema);
  },
  /**
   * Inbox feed using the shared server view vocabulary. The API defaults to
   * open, identified contacts; product surfaces opt into anonymous rows when
   * that is their declared default.
   */
  inbox: (
    view: InboxView,
    options: {
      includeAnonymous?: boolean;
      // open (default): closed=false. closed: closed=true. any: both.
      closedFilter?: "open" | "closed" | "any";
      // Cap results to leads active in the last hour.
      recent?: boolean;
      // Ordering: recent (default, freshest first), waiting (longest
      // awaiting a reply first), newest (by lead creation).
      sort?: "recent" | "waiting" | "newest";
      filters?: ListFilterState;
      /** Server-side full-text search (B5): contact trgm + message bodies. */
      search?: string;
      /** Keyset cursor from the previous page's `nextCursor`. */
      cursor?: string | null;
      limit?: number;
    } = {},
  ): Promise<LeadFeed> => {
    const params = new URLSearchParams({ view });
    if (options.includeAnonymous) params.set("includeAnonymous", "true");
    if (options.closedFilter === "closed") params.set("closed", "true");
    else if (options.closedFilter === "any") params.set("closed", "any");
    if (options.recent) params.set("recent", "true");
    if (options.sort && options.sort !== "recent") params.set("sort", options.sort);
    if (options.filters) appendListFilterParams(params, options.filters);
    if (options.search?.trim()) params.set("search", options.search.trim());
    if (options.cursor) params.set("cursor", options.cursor);
    if (options.limit) params.set("limit", String(options.limit));
    return apiFetch(`/inbox?${params.toString()}`, LeadFeedSchema);
  },
  /**
   * "Needs you" banded priority queue (B4) — GET /inbox/needs-you. Its
   * own route (not `?view=needs_you`) because the rows carry
   * band/bandReason/bandAt that a plain LeadFeed parse would strip, and
   * because the inbox's "Needs you" tab is now a normal sortable view.
   * This banded feed serves Home's Answer-Now queue.
   */
  needsYou: (
    options: {
      includeAnonymous?: boolean;
      filters?: ListFilterState;
      search?: string;
      cursor?: string | null;
      limit?: number;
    } = {},
  ): Promise<NeedsYouFeed> => {
    const params = new URLSearchParams();
    if (options.includeAnonymous) params.set("includeAnonymous", "true");
    if (options.filters) appendListFilterParams(params, options.filters);
    if (options.search?.trim()) params.set("search", options.search.trim());
    if (options.cursor) params.set("cursor", options.cursor);
    if (options.limit) params.set("limit", String(options.limit));
    const qs = params.toString();
    return apiFetch(`/inbox/needs-you${qs ? `?${qs}` : ""}`, NeedsYouFeedSchema);
  },
  /**
   * Real per-view inbox totals in one grouped scan (B3) — replaces every
   * client-side `items.length` badge count (those lie: they count a
   * capped page, not the view).
   */
  inboxCounts: (
    options: {
      includeAnonymous?: boolean;
      closedFilter?: "open" | "closed" | "any";
      filters?: ListFilterState;
      search?: string;
    } = {},
  ): Promise<InboxCounts> => {
    const params = new URLSearchParams();
    if (options.includeAnonymous) params.set("includeAnonymous", "true");
    if (options.closedFilter === "closed") params.set("closed", "true");
    else if (options.closedFilter === "any") params.set("closed", "any");
    if (options.filters) appendListFilterParams(params, options.filters);
    if (options.search?.trim()) params.set("search", options.search.trim());
    const qs = params.toString();
    return apiFetch(`/inbox/counts${qs ? `?${qs}` : ""}`, InboxCountsSchema) as Promise<InboxCounts>;
  },
  /**
   * Bulk triage (B6) — POST /leads/bulk with explicit lead ids. The
   * response is an honest split: `ok` applied, `failed` with a per-lead
   * reason (policy re-validation happens server-side per lead).
   */
  bulkLeads: (input: BulkLeadActionInput): Promise<BulkLeadActionResult> => {
    const body = BulkLeadActionSchema.parse(input);
    return apiFetch("/leads/bulk", BulkLeadActionResultSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  /**
   * Robust duplicate-merge: pick a winner contact and 1+ losers; the
   * server reparents every child row (leads, activities,
   * appointments, trade-ins, vehicle interests, follow-ups,
   * contact_channels, integration_contacts, consent_events) onto the
   * winner inside a single transaction, consolidates duplicate open
   * leads on the same channel pair, applies field-conflict
   * resolution, snapshots each loser for the undo window, and emits
   * an audit `system_event` activity on the winner. See
   * docs/plans/CONTACT_MERGE.md.
   */
  mergeContacts: (input: MergeContactsDto): Promise<MergeContactsResult> => {
    const body = MergeContactsSchema.parse(input);
    return apiFetch("/contacts/merge", MergeContactsResultSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  getLead: (leadId: string): Promise<Lead> =>
    apiFetch(`/leads/${leadId}`, LeadSchema),

  // Generate (or return the cached) lead-level AI summary for the
  // Customer 360 panel's "Lead summary" block.
  generateLeadAiSummary: (leadId: string) =>
    apiFetch(
      `/leads/${leadId}/ai-summary`,
      LeadAiSummaryResultSchema,
      { method: "POST" },
    ),
  createLead: (
    input: Omit<CreateLeadDto, "dealershipId">,
  ): Promise<Lead> => {
    const body = CreateLeadSchema.omit({ dealershipId: true }).parse(input);
    return apiFetch("/leads", LeadSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  /** Start a new SMS/email conversation with a contact + send the first
   * message; returns the lead to navigate to. */
  startConversation: (
    contactId: string,
    input: StartConversationDto,
  ): Promise<Lead> =>
    apiFetch(`/contacts/${contactId}/start-conversation`, LeadSchema, {
      method: "POST",
      body: JSON.stringify(input),
    }),
  updateLead: (
    leadId: string,
    input: UpdateLeadDto,
  ): Promise<Lead> => {
    const body = UpdateLeadSchema.parse(input);
    return apiFetch(`/leads/${leadId}`, LeadSchema, {
      method: "PATCH",
      body: JSON.stringify(body),
    });
  },
  assignLead: (
    leadId: string,
    input: LeadAssignDto,
  ): Promise<Lead> => {
    const body = LeadAssignSchema.parse(input);
    return apiFetch(`/leads/${leadId}/assign`, LeadSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  closeLead: (leadId: string): Promise<Lead> =>
    apiFetch(`/leads/${leadId}/close`, LeadSchema, { method: "POST" }),
  reopenLead: (leadId: string): Promise<Lead> =>
    apiFetch(`/leads/${leadId}/reopen`, LeadSchema, { method: "POST" }),
  markLeadRead: (leadId: string): Promise<Lead> =>
    apiFetch(`/leads/${leadId}/read`, LeadSchema, { method: "POST" }),
  markLeadUnread: (leadId: string): Promise<Lead> =>
    apiFetch(`/leads/${leadId}/unread`, LeadSchema, { method: "POST" }),
  snoozeLead: (
    leadId: string,
    input: LeadSnoozeDto,
  ): Promise<Lead> => {
    const body = LeadSnoozeSchema.parse(input);
    return apiFetch(`/leads/${leadId}/snooze`, LeadSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  internalNote: (leadId: string, input: InternalNoteDto): Promise<Activity> => {
    const body = InternalNoteSchema.parse(input);
    return apiFetch(`/leads/${leadId}/internal-notes`, ActivitySchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  sendLeadMessage: (
    leadId: string,
    input: SendLeadMessageDto,
  ): Promise<Activity> => {
    const body = SendLeadMessageSchema.parse(input);
    return apiFetch(`/leads/${leadId}/messages`, ActivitySchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  /**
   * D9 — retry a FAILED outbound send: re-publishes the activity to
   * the outbox with `redrive: true`. The backend validates the row is
   * actually `failed` and visible to the caller.
   */
  retryActivity: async (leadId: string, activityId: string): Promise<void> => {
    // Tolerant of both void and Activity-returning implementations.
    await apiFetch(`/leads/${leadId}/activities/${activityId}/retry`, z.unknown(), {
      method: "POST",
    });
  },
  /**
   * D10 — cancel a SCHEDULED send before it's due (deletes the queued
   * activity carrying `metadata.sendAfter`).
   */
  cancelScheduledActivity: async (
    leadId: string,
    activityId: string,
  ): Promise<void> => {
    await apiFetch(`/leads/${leadId}/activities/${activityId}`, z.unknown(), {
      method: "DELETE",
    });
  },
  /**
   * D12 — operator-typing signal for a web-widget lead. Ephemeral,
   * fire-and-forget; the widget shows auto-expiring typing dots.
   */
  notifyTyping: async (leadId: string): Promise<void> => {
    await apiFetch(`/leads/${leadId}/typing`, z.unknown(), { method: "POST" });
  },
  /**
   * "Suggest a response" — run the dealership AI agent draft-only and
   * return its reply for the operator to drop into the composer.
   * Nothing is sent or persisted server-side.
   */
  suggestResponse: (leadId: string): Promise<{ text: string }> =>
    apiFetch(
      `/leads/${leadId}/suggest-response`,
      SuggestedResponseSchema,
      { method: "POST" },
    ),
  /**
   * Mint a presigned PUT URL for one outbound attachment. The caller
   * then `fetch(uploadUrl, { method: "PUT", body: file })` to push the
   * bytes directly to S3 (no server round-trip), and finally sends a
   * sendLeadMessage with `{ key, storage, mimeType, kind, ... }`.
   */
  createAttachmentUploadUrl: (
    leadId: string,
    input: CreateAttachmentUploadUrlDto,
  ): Promise<AttachmentUploadUrlResult> => {
    const body = CreateAttachmentUploadUrlSchema.parse(input);
    return apiFetch(
      `/leads/${leadId}/attachments/upload-url`,
      AttachmentUploadUrlResultSchema,
      { method: "POST", body: JSON.stringify(body) },
    );
  },
  transcribeAttachment: (
    activityId: string,
    attachmentIndex: number,
  ): Promise<TranscribeAttachmentResult> =>
    apiFetch(`/attachments/transcribe`, TranscribeAttachmentResultSchema, {
      method: "POST",
      body: JSON.stringify({ activityId, attachmentIndex }),
    }),
  generateActivityAiSummary: (activityId: string): Promise<{ aiSummary: string }> =>
    apiFetch(
      `/activities/${activityId}/ai-summary`,
      z.object({ aiSummary: z.string() }),
      { method: "POST" },
    ),
  verifyChannel: (channelId: string) =>
    apiFetch(`/channels/${channelId}/verify`, ChannelVerifyResultSchema, { method: "POST" }),
  activities: (
    leadId?: string,
    contactId?: string,
    options: { order?: "asc" | "desc"; pageSize?: number; page?: number } = {},
  ): Promise<ActivityPage> => {
    const params = new URLSearchParams();
    if (leadId) params.set("leadId", leadId);
    if (contactId) params.set("contactId", contactId);
    if (options.order) params.set("order", options.order);
    if (options.pageSize) params.set("pageSize", String(options.pageSize));
    if (options.page) params.set("page", String(options.page));
    const qs = params.toString() ? `?${params.toString()}` : "";
    return apiFetch(`/activities${qs}`, ActivityPageSchema);
  },
  /** Exact, filter-complete Contact 360 activity page with page-scoped Leads. */
  contactActivity: (
    contactId: string,
    options: {
      filter?: ContactActivityFilter;
      page?: number;
      pageSize?: number;
    } = {},
  ): Promise<ContactActivityPage> => {
    const params = new URLSearchParams();
    if (options.filter) params.set("filter", options.filter);
    if (options.page) params.set("page", String(options.page));
    if (options.pageSize) params.set("pageSize", String(options.pageSize));
    const qs = params.toString();
    return apiFetch(
      `/contacts/${contactId}/activity${qs ? `?${qs}` : ""}`,
      ContactActivityPageSchema,
    );
  },
  // Generic appointment page for contact/detail widgets and global search.
  // The operational Calendar uses calendarAppointments below because it needs
  // the full filter set and explicit page exhaustion over a date window.
  appointments: (
    contactId?: string,
    opts: {
      from?: string;
      to?: string;
      page?: number;
      pageSize?: number;
      /** Free text over the contact's name/email/phone, notes and VIN. */
      search?: string;
    } = {},
  ): Promise<CalendarAppointmentPage> => {
    // Detail widgets historically request up to 100; per-contact 360 tabs
    // override this with page/pageSize for "Show more".
    const params = new URLSearchParams({
      pageSize: String(opts.pageSize ?? 100),
    });
    if (contactId) params.set("contactId", contactId);
    if (opts.from) params.set("from", opts.from);
    if (opts.to) params.set("to", opts.to);
    if (opts.page) params.set("page", String(opts.page));
    if (opts.search) params.set("search", opts.search);
    return apiFetch(
      `/appointments?${params.toString()}`,
      CalendarAppointmentPageSchema,
    );
  },
  calendarAppointments: (
    query: Omit<CalendarAppointmentQuery, "page" | "pageSize"> & {
      page?: number;
      pageSize?: number;
    },
  ): Promise<CalendarAppointmentPage> => {
    const params = new URLSearchParams({
      from: query.from,
      to: query.to,
      filter: query.filter,
      page: String(query.page ?? 1),
      pageSize: String(query.pageSize ?? 100),
    });
    if (query.assignedUserId) {
      params.set("assignedUserId", query.assignedUserId);
    }
    if (query.rooftopId) params.set("rooftopId", query.rooftopId);
    if (query.appointmentType) {
      params.set("appointmentType", query.appointmentType);
    }
    return apiFetch(
      `/appointments/calendar?${params.toString()}`,
      CalendarAppointmentPageSchema,
    );
  },
  /** Single appointment by id — backs the `/calendar?appointmentId=`
   * deep-link, which must open any appointment, not just one in the
   * currently loaded calendar window. */
  appointment: (appointmentId: string): Promise<Appointment> =>
    apiFetch(`/appointments/${appointmentId}`, AppointmentSchema),
  createAppointment: (input: Omit<CreateAppointmentDto, "dealershipId">): Promise<Appointment> => {
    const body = CreateAppointmentSchema.omit({ dealershipId: true }).parse(input);
    return apiFetch("/appointments", AppointmentSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  updateAppointment: (appointmentId: string, input: UpdateAppointmentDto): Promise<Appointment> => {
    const body = UpdateAppointmentSchema.parse(input);
    return apiFetch(`/appointments/${appointmentId}`, AppointmentSchema, {
      method: "PATCH",
      body: JSON.stringify(body),
    });
  },
  /** Per-rooftop appointment catalog — the booking dialog's service-type
   * picker (drives the reminder ladder's template). */
  serviceTypes: (): Promise<ServiceType[]> =>
    apiFetch("/service-types", ServiceTypeListSchema),
  channels: (): Promise<ChannelPage> => apiFetch("/channels", ChannelPageSchema),
  /** Single channel by id — the channel settings page's loader. */
  channel: (channelId: string): Promise<Channel> =>
    apiFetch(`/channels/${channelId}`, ChannelSchema),
  /** "Request ADF email" — (re)provision a rooftop's lead-intake
   * address when onboarding missed it. Idempotent. */
  requestAdfIntake: (rooftopId: string): Promise<Channel> =>
    apiFetch(`/channels/adf-intake/${rooftopId}`, ChannelSchema, {
      method: "POST",
    }),
  // No createChannel: channels are created by the connect flows above
  // (connectWidgetChannel / connectApiChannel / connectTelegramChannel /
  // connectEmailChannel / connectAapChannel) or by telephony/Meta
  // provisioning — never by a raw create.
  updateChannel: (channelId: string, input: UpdateChannelDto): Promise<Channel> => {
    const body = UpdateChannelSchema.parse(input);
    return apiFetch(`/channels/${channelId}`, ChannelSchema, {
      method: "PATCH",
      body: JSON.stringify(body),
    });
  },
  removeChannel: (channelId: string): Promise<void> =>
    apiFetch(`/channels/${channelId}`, ChannelSchema.optional(), {
      method: "DELETE",
    }) as Promise<void>,
  /**
   * Deauthorize (not delete): unsubscribes the provider webhook,
   * clears credentials, parks the channel at `status='released'`. The
   * row + lead history are kept; reconnecting re-uses it.
   */
  deauthorizeChannel: (channelId: string): Promise<Channel> =>
    apiFetch(`/channels/${channelId}/deauthorize`, ChannelSchema, { method: "POST" }),

  // -------------------------------------------------------------------------
  // Per-channel onboarding (Podium-style "Connect <provider>")
  // -------------------------------------------------------------------------
  connectApiChannel: (input: ConnectApiChannelDto): Promise<ChannelOnboardingInfo> => {
    const body = ConnectApiChannelSchema.parse(input);
    return apiFetch("/channels/connect/api", ChannelOnboardingInfoSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  connectAapChannel: (input: ConnectAapChannelDto): Promise<ChannelOnboardingInfo> => {
    const body = ConnectAapChannelSchema.parse(input);
    return apiFetch("/channels/connect/aap", ChannelOnboardingInfoSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  /** Returns the canonical agent card for the current dealership. */
  aapAgentCard: (dealershipId: string): Promise<AgentCard> =>
    apiFetch(`/aap/${dealershipId}/agent-card.json`, AgentCardSchema),
  /**
   * Fetch the dealer's hosted agent-card.json and diff it against
   * the expected JSON. Flips the channel status server-side —
   * never call from a user-driven status switch.
   */
  validateAap: (channelId: string): Promise<AapValidationResult> =>
    apiFetch(`/channels/${channelId}/validate-aap`, AapValidationResultSchema, {
      method: "POST",
    }),
  connectWidgetChannel: (input: ConnectWidgetChannelDto): Promise<ChannelOnboardingInfo> => {
    const body = ConnectWidgetChannelSchema.parse(input);
    return apiFetch("/channels/connect/widget", ChannelOnboardingInfoSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  connectTelegramChannel: (
    input: ConnectTelegramChannelDto,
  ): Promise<ChannelOnboardingInfo> => {
    const body = ConnectTelegramChannelSchema.parse(input);
    return apiFetch("/channels/connect/telegram", ChannelOnboardingInfoSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  connectEmailChannel: (input: ConnectEmailChannelDto): Promise<ChannelOnboardingInfo> => {
    const body = ConnectEmailChannelSchema.parse(input);
    return apiFetch("/channels/connect/email", ChannelOnboardingInfoSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  /** Live availability check — the endpoint is auth-scoped to the caller's dealership. */
  checkEmailAvailability: (
    localPart: string,
    subdomain: string,
  ): Promise<EmailAddressAvailability> =>
    apiFetch(
      `/channels/email/availability?localPart=${encodeURIComponent(localPart)}&subdomain=${encodeURIComponent(subdomain)}`,
      EmailAddressAvailabilitySchema,
    ),
  startMetaOAuth: (input: StartMetaOAuthDto): Promise<{ authUrl: string }> => {
    const params = new URLSearchParams({ channelType: input.channelType });
    // Omit rooftopId for group-wide ("All rooftops"); a GET query param can't
    // carry null, so absence is how the backend reads group-wide.
    if (input.rooftopId) params.set("rooftopId", input.rooftopId);
    return apiFetch(
      `/channels/oauth/meta/start?${params.toString()}`,
      MetaOAuthStartResponseSchema,
    );
  },
  hostedMetaAvailability: () => apiFetch("/channels/connect-session/availability", z.object({ enabled: z.boolean() })),
  startHostedMeta: (input: { rooftopId: string | null; kind: "meta_whatsapp"; settings: Record<string, unknown> }) =>
    apiFetch("/channels/connect-session", z.object({ sessionId: z.string(), url: z.string().url() }), { method: "POST", body: JSON.stringify(input) }),
  completeHostedMeta: (sessionId: string) => apiFetch("/channels/connect-session/return", z.object({
    state: z.enum(["pending", "granted", "cancelled", "failed", "expired", "applying", "applied"]),
    channels: z.array(z.object({ id: z.string() })), error: z.string().nullable(),
  }), { method: "POST", body: JSON.stringify({ sessionId }) }),
  connectWhatsAppEmbeddedSignup: (
    input: ConnectWhatsAppEmbeddedSignupDto,
  ): Promise<ChannelOnboardingInfo> => {
    const body = ConnectWhatsAppEmbeddedSignupSchema.parse(input);
    return apiFetch(
      "/channels/oauth/whatsapp/embedded-signup",
      ChannelOnboardingInfoSchema,
      { method: "POST", body: JSON.stringify(body) },
    );
  },
  channelOnboardingInfo: (channelId: string): Promise<ChannelOnboardingInfo> =>
    apiFetch(`/channels/${channelId}/onboarding`, ChannelOnboardingInfoSchema),
  whatsAppEmbeddedSignupConfig: (): Promise<{
    appId: string | null;
    configId: string | null;
    graphVersion: string;
  }> =>
    apiFetch(
      "/channels/meta/whatsapp-config",
      z.object({
        appId: z.string().nullable(),
        configId: z.string().nullable(),
        graphVersion: z.string(),
      }),
    ),
  // Inventory CRUD on the dealer surface is deliberately gone — the
  // dealer Inventory page is read-only (see `apps/frontend/src/api/vehicles.ts`).
  // Manual CRUD lives in the admin portal only.

  followUps: (
    contactId?: string,
    opts: { page?: number; pageSize?: number } = {},
  ): Promise<FollowUpPage> => {
    const qs = contactListQuery(contactId, opts);
    return apiFetch(`/follow-ups${qs}`, FollowUpPageSchema);
  },
  createFollowUp: (input: Omit<CreateFollowUpDto, "dealershipId">): Promise<FollowUp> => {
    const body = CreateFollowUpSchema.omit({ dealershipId: true }).parse(input);
    return apiFetch("/follow-ups", FollowUpSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  completeFollowUp: (followUpId: string): Promise<FollowUp> =>
    apiFetch(`/follow-ups/${followUpId}/complete`, FollowUpSchema, { method: "POST" }),

  consentEvents: (
    contactId?: string,
    opts: { page?: number; pageSize?: number } = {},
  ): Promise<ConsentEventPage> => {
    const qs = contactListQuery(contactId, opts);
    return apiFetch(`/consent-events${qs}`, ConsentEventPageSchema);
  },
  recordConsent: (input: Omit<CreateConsentEventDto, "dealershipId">): Promise<ConsentEvent> => {
    const body = CreateConsentEventSchema.omit({ dealershipId: true }).parse(input);
    return apiFetch("/consent-events", ConsentEventSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  tradeIns: (
    contactId?: string,
    opts: { page?: number; pageSize?: number } = {},
  ): Promise<TradeInPage> => {
    const qs = contactListQuery(contactId, opts);
    return apiFetch(`/trade-ins${qs}`, TradeInPageSchema);
  },
  createTradeIn: (input: Omit<CreateTradeInDto, "dealershipId">): Promise<TradeIn> => {
    const body = CreateTradeInSchema.omit({ dealershipId: true }).parse(input);
    return apiFetch("/trade-ins", TradeInSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  vehicleInterests: (
    contactId?: string,
    opts: { page?: number; pageSize?: number } = {},
  ): Promise<VehicleInterestPage> => {
    const qs = contactListQuery(contactId, opts);
    return apiFetch(`/vehicle-interests${qs}`, VehicleInterestPageSchema);
  },
  addVehicleInterest: (
    input: Omit<CreateVehicleInterestDto, "dealershipId">,
  ): Promise<VehicleInterest> => {
    const body = CreateVehicleInterestSchema.omit({ dealershipId: true }).parse(input);
    return apiFetch("/vehicle-interests", VehicleInterestSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  contactVehicles: (
    contactId?: string,
    opts: { page?: number; pageSize?: number } = {},
  ): Promise<ContactVehiclePage> => {
    const qs = contactListQuery(contactId, opts);
    return apiFetch(`/contact-vehicles${qs}`, ContactVehiclePageSchema);
  },

  // Read-only external-sync ledger for a contact (Space Auto / ADF) — the
  // Customer 360 panel's "Integrations" block.
  contactIntegrationSyncs: (contactId: string): Promise<ContactIntegrationSync[]> =>
    apiFetch(
      `/contacts/${contactId}/integration-syncs`,
      z.array(ContactIntegrationSyncSchema),
    ),

  upsertContactVehicle: (
    input: Omit<CreateContactVehicleDto, "dealershipId">,
  ): Promise<ContactVehicle> => {
    const body = CreateContactVehicleSchema.omit({ dealershipId: true }).parse(input);
    return apiFetch("/contact-vehicles", ContactVehicleSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  /**
   * Run-trace inspector (UIUX §6.2 / C4): the lead's recent agent runs —
   * tool calls, timings, tokens, outcome. Policy-scoped, newest first,
   * limit 20 server-side.
   */
  leadAgentRuns: (leadId: string): Promise<AgentRun[]> =>
    apiFetch(`/leads/${leadId}/agent-runs`, AgentRunListSchema),
  /**
   * Approve a pending_approval AI draft (C2): validates status + policy,
   * enqueues the outbox send (delivery_status → queued).
   */
  approveActivity: (leadId: string, activityId: string): Promise<Activity> =>
    apiFetch(
      `/leads/${leadId}/activities/${activityId}/approve`,
      ActivitySchema,
      { method: "POST" },
    ),
  /**
   * Reject a pending_approval AI draft (C2): delivery_status → rejected,
   * stamps the lead's needsHumanAt so the customer isn't silently dropped.
   */
  rejectActivity: (
    leadId: string,
    activityId: string,
    input: RejectActivityApprovalDto = {},
  ): Promise<Activity> => {
    const body = RejectActivityApprovalSchema.parse(input);
    return apiFetch(
      `/leads/${leadId}/activities/${activityId}/reject`,
      ActivitySchema,
      { method: "POST", body: JSON.stringify(body) },
    );
  },
  /** Month-to-date AI spend vs the monthly cap (C7) — the settings meter. */
  aiBudgetSummary: (): Promise<AiBudgetSummary> =>
    apiFetch("/ai/usage-summary", AiBudgetSummarySchema),

  aiAgents: (): Promise<AiAgent[]> => apiFetch("/ai-agents", AiAgentListSchema),
  updateAiAgent: (agentId: string, input: UpdateAiAgentDto): Promise<AiAgent> => {
    const body = UpdateAiAgentSchema.parse(input);
    return apiFetch(`/ai-agents/${agentId}`, AiAgentSchema, {
      method: "PATCH",
      body: JSON.stringify(body),
    });
  },

  aiSkills: (): Promise<AiSkill[]> => apiFetch("/ai-skills", AiSkillListSchema),
  createAiSkill: (
    input: Omit<CreateAiSkillDto, "dealershipId">,
  ): Promise<AiSkill> => {
    const body = CreateAiSkillSchema.omit({ dealershipId: true }).parse(input);
    return apiFetch("/ai-skills", AiSkillSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  updateAiSkill: (skillId: string, input: UpdateAiSkillDto): Promise<AiSkill> => {
    const body = UpdateAiSkillSchema.parse(input);
    return apiFetch(`/ai-skills/${skillId}`, AiSkillSchema, {
      method: "PATCH",
      body: JSON.stringify(body),
    });
  },
  removeAiSkill: (skillId: string): Promise<void> =>
    apiFetch(`/ai-skills/${skillId}`, AiSkillSchema.optional(), {
      method: "DELETE",
    }) as Promise<void>,

  /** Per-rooftop Knowledge & Behavior additions. */
  aiRooftopPrompts: (): Promise<AiRooftopPrompt[]> =>
    apiFetch("/ai-rooftop-prompts", AiRooftopPromptListSchema),
  upsertAiRooftopPrompt: (
    input: UpsertAiRooftopPromptDto,
  ): Promise<AiRooftopPrompt> => {
    const body = UpsertAiRooftopPromptSchema.parse(input);
    return apiFetch("/ai-rooftop-prompts", AiRooftopPromptSchema, {
      method: "PUT",
      body: JSON.stringify(body),
    });
  },
  removeAiRooftopPrompt: (rooftopId: string): Promise<void> =>
    apiFetch(`/ai-rooftop-prompts/${rooftopId}`, AiRooftopPromptSchema.optional(), {
      method: "DELETE",
    }) as Promise<void>,

  tags: (): Promise<Tag[]> => apiFetch("/tags", TagListSchema),
  createTag: (input: Omit<CreateTagDto, "dealershipId">): Promise<Tag> => {
    const body = CreateTagSchema.omit({ dealershipId: true }).parse(input);
    return apiFetch("/tags", TagSchema, { method: "POST", body: JSON.stringify(body) });
  },
  updateTag: (tagId: string, input: UpdateTagDto): Promise<Tag> => {
    const body = UpdateTagSchema.parse(input);
    return apiFetch(`/tags/${tagId}`, TagSchema, {
      method: "PATCH",
      body: JSON.stringify(body),
    });
  },
  removeTag: (tagId: string): Promise<void> =>
    apiFetch(`/tags/${tagId}`, TagSchema.optional(), { method: "DELETE" }) as Promise<void>,

  contactTags: (contactId: string): Promise<ContactTag[]> =>
    apiFetch(`/contacts/${contactId}/tags`, ContactTagListSchema),
  allContactTags: (): Promise<ContactTag[]> =>
    apiFetch(`/contact-tags`, ContactTagListSchema),
  addContactTag: (contactId: string, tagId: string): Promise<ContactTag> =>
    apiFetch(`/contacts/${contactId}/tags/${tagId}`, ContactTagSchema, {
      method: "POST",
    }),
  removeContactTag: (contactId: string, tagId: string): Promise<void> =>
    apiFetch(`/contacts/${contactId}/tags/${tagId}`, ContactTagSchema.optional(), {
      method: "DELETE",
    }) as Promise<void>,
};
